import {Component, OnDestroy} from '@angular/core';
import {Observable, Subscription} from "rxjs";

@Component({
    standalone: true,
    template: '',
})
export class SubscriptionHandlerComponent implements OnDestroy {
    protected subscriptions: Subscription[] = [];

    ngOnDestroy(): void {
        this.subscriptions.forEach(s => {
            s.unsubscribe();
        });
    }

    subscribeTo<T>(observable: Observable<T>, callback: (value: T) => void): void {
        const subscription = observable.subscribe(callback);
        this.subscriptions.push(subscription);
    }
}
